module.exports = __webpack_public_path__ + "img/szkola.6beb1b54.png";